import { PairedItem } from './comptiaReportPair';

// Codes describe course order only; the export has no completion timestamps.
function compareCodes(left: string, right: string): number {
  const a = left.split('.'); const b = right.split('.');
  for (let i = 0; i < Math.max(a.length, b.length); i++) {
    if (a[i] === undefined) return -1;
    if (b[i] === undefined) return 1;
    const comparison = /^\d+$/.test(a[i]) && /^\d+$/.test(b[i])
      ? Number(a[i]) - Number(b[i]) : a[i].localeCompare(b[i]);
    if (comparison) return comparison;
  }
  return 0;
}
const assessment = (item: PairedItem) => item.kind.toLowerCase() === 'assessment';
// Zero time with no result is valid report coverage, but not a useful activity
// example. Keep explicit zero scores/statuses and positive time-only records.
export function comptiaActivityExamples(items: PairedItem[], limit = 8): PairedItem[] {
  return items.filter(item => item.result.trim() || (item.seconds !== null && item.seconds > 0))
    .sort((a, b) => compareCodes(b.code, a.code)).slice(0, limit);
}
function finished(item: PairedItem): boolean {
  const result = item.result.trim().toLowerCase();
  if (assessment(item)) {
    return result === 'passed' || (/^\d+(?:\.\d+)?%$/.test(result) && Number(result.slice(0, -1)) >= 80 && Number(result.slice(0, -1)) <= 100);
  }
  return ['complete', 'completed', 'passed', '100%'].includes(result);
}
export function comptiaProgressPosition(items: PairedItem[]) {
  const ordered = [...items].sort((a, b) => compareCodes(a.code, b.code));
  const completed = ordered.filter(finished);
  const activity = completed.filter(item => !assessment(item)).pop() || null;
  const passedAssessment = completed.filter(assessment).pop() || null;
  const highest = completed[completed.length - 1];
  // Include unfinished/unknown siblings at the same code; never assume no gaps.
  const earlier = highest ? ordered.filter(item => compareCodes(item.code, highest.code) <= 0 && !finished(item)) : [];
  return { activity, assessment: passedAssessment, earlier };
}
